import { Z_MAX_BASE } from "./z-index";

export const modalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    overflow: "hidden",
  },
  overlay: { backgroundColor: "rgba(0,0,0,.5)", zIndex: Z_MAX_BASE },
};
